import { passById, type PassId } from '../data/passes'

export function PassChip({ id }: { id: PassId }) {
  const p = passById(id)
  return <span className={`chip ${id}`}>{p.short}</span>
}
